import React, { FC } from "react";
import { ModalDialog } from "../../../../components";
import TEXT from "../../../text-consts";

interface CreditCheckModalProps {
    creditCheckMessage: string;
    onContinue: () => void;
}

const CreditCheckModal: FC<CreditCheckModalProps> = ({ creditCheckMessage, onContinue }) => {
    if (creditCheckMessage) {
        return (
            <ModalDialog
                size="medium"
                name="creditcheck-message-modal"
                heading={TEXT.COMMON.WARNING}
                submitText={TEXT.COMMON.CONTINUE}
                onSubmit={onContinue}
                data-di-mask
            >
                <div data-di-mask dangerouslySetInnerHTML={{ __html: creditCheckMessage }} />
            </ModalDialog>
        );
    }
    return null;
};

export default CreditCheckModal;
